import { Provider } from "react-redux"
import { AppProvider } from "./providers"
import Routes from "./routes/Routes"
import store from "./store"
import "./styles/global.css"
import { ToastContainer } from "react-toastify"

function App() {
  
    return (
        <div className="App">
            <ToastContainer />
            <Provider store={store}>
                <AppProvider>
                    <Routes />
                </AppProvider>
            </Provider>
        </div>
    )
}

export default App;
